/// <amd-module name="Search/WorkItem/Flux/Sources/PivotStateServiceSpy" />

import * as BaseActionsHub from "Search/Shared/Base/ActionsHub";
import { ISearchPivotStateService } from "Search/Shared/Base/PivotStateService";
import { IVssPageContext } from "VSS/Platform/Context";
import { serializeFilters } from "Search/Shared/Utils";
import { ActionsHub } from "Search/WorkItem/Flux/ActionsHub";
import { WorkItemSearchRequest, WorkItemResult, WorkItemSearchResponse } from "Search/LegacyWebApi/Contracts/WorkItem";
import { EntityTypeUrlParam } from "Search/WorkItem/Constants";

export class PivotStateServiceSpy {
    private readonly pivotStateService: ISearchPivotStateService ;

    constructor(
        private pageContext: IVssPageContext,
        private actionsHub: ActionsHub) {
            this.pivotStateService = this.pageContext.getService<ISearchPivotStateService>("ISearchPivotStateService");
            this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.searchStarted.addListener(this.storeCurrentFilters);
        this.actionsHub.pageInitializationStarted.addListener(this.storeCurrentFilters);
        this.actionsHub.filterReset.addListener(this.resetFilters);
        this.actionsHub.resultsLoaded.addListener(this.storeCurrentResultsCount);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.removeListener(this.storeCurrentResultsCount);
        this.actionsHub.searchStarted.removeListener(this.storeCurrentFilters);
        this.actionsHub.pageInitializationStarted.removeListener(this.storeCurrentFilters);
        this.actionsHub.filterReset.removeListener(this.resetFilters);
    }

    public resetFilters = (): void => {
        this.pivotStateService.resetFilters(EntityTypeUrlParam);
    }

    public storeCurrentFilters = (payload: BaseActionsHub.ISearchStartedPayload<WorkItemSearchRequest>): void => {
        this.pivotStateService.updateState(EntityTypeUrlParam, serializeFilters(payload.request.searchFilters));
    }

    public storeCurrentResultsCount = (payload: BaseActionsHub.IResultsLoadedPayload<WorkItemSearchResponse, WorkItemResult>): void => {
        const count = payload.response.results.count;
        this.pivotStateService.updateState(EntityTypeUrlParam, undefined, undefined, { searchtext: payload.response.query.searchText, count });
    }
}
